import React from "react";
import { DialogButton, DialogConfig, createDialogConfig } from "common/component/SequentialDialog";
import { createButton, getReportTypeDisplayName, getArticle } from "./utils";
import { SfReportType } from "./types";

const createContent = (
  selectedReportType: string,
  authorizedReportTypes: SfReportType[]
): React.ReactNode => {
  const report = authorizedReportTypes.find(item => item.reportType === selectedReportType);
  const reportTypeStr = report 
    ? getReportTypeDisplayName(report.reportType, report.caseNumber)
    : getReportTypeDisplayName(selectedReportType);
  
  const article = getArticle(reportTypeStr);
  return (
    <div>
      {article} {reportTypeStr} has already been authorized for this authorization. 
      Do you want to submit an update for this report?
    </div>
  );
};

const createButtons = (): DialogButton[] => [
  createButton('Submit', { action: 'submit', updateExistingReport: true })
];

export const createReportAcceptedDialogConfig = (
  selectedReportType: string,
  authorizedReportTypes: SfReportType[],
  shouldShow: boolean
): DialogConfig => {
  return createDialogConfig(
    'report-accepted-confirmation',
    'Confirm!',
    createContent(selectedReportType, authorizedReportTypes),
    createButtons(),
    shouldShow
  );
};
